import Controller from '@ember/controller';
import { action } from '@ember/object';

export default class IndividualResultsController extends Controller 
{
	@action
	refresh()
	{
		this.target.send('refreshModel');
	}
}